import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface IDialodBox {
  open: boolean;
  closeDialog: () => void;
  deleteApp: () => void;
}

const DialogBox = ({ open, closeDialog, deleteApp }: IDialodBox) => (
  <Dialog open={open} onClose={closeDialog}>
    <DialogTitle id="alert-dialog-title">Delete Confimation</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Are sure want to delete the Application?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={closeDialog} autoFocus>
        Cancel
      </Button>
      <Button onClick={deleteApp} color="error">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DialogBox;
